/**
 * Zod schemas for workspace API validation
 */

import { z } from 'zod';

// Workspace status enum
export const WorkspaceStatusSchema = z.enum(['building', 'starting', 'running', 'terminated', 'error']);

// Single workspace response
export const WorkspaceSchema = z.object({
  id: z.string(),
  project_id: z.string(),
  project_name: z.string(),
  branch: z.string(),
  status: WorkspaceStatusSchema,
  url: z.string().nullable(),
  error_message: z.string().nullable().optional(),
  created_at: z.string(),
  started_at: z.string().nullable().optional(),
  expires_at: z.string().nullable().optional(),
  termination_reason: z.string().nullable().optional(),
  features: z.array(z.string()).optional().default([]),
});

// List of workspaces response
export const WorkspaceListResponseSchema = z.object({
  workspaces: z.array(WorkspaceSchema),
});

// Create workspace request (for validation before sending)
export const CreateWorkspaceRequestSchema = z.object({
  project_id: z.string().uuid(),
  branch: z.string().min(1),
});

// Inferred types from schemas
export type WorkspaceStatus = z.infer<typeof WorkspaceStatusSchema>;
export type Workspace = z.infer<typeof WorkspaceSchema>;
export type WorkspaceListResponse = z.infer<typeof WorkspaceListResponseSchema>;
export type CreateWorkspaceRequest = z.infer<typeof CreateWorkspaceRequestSchema>;
